import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { TripTypes } from '@model/common';
import Cookies, { Cookie } from '@model/common/cookie/cookie';
import { closeModal, ModalType } from '@state/slices/modal/modalSlice';
import { getModalType } from '@state/slices/modal/modalSelectors';
import { getPromoBannerData } from '@state/slices/promo-banner/promoBannerSelectors';
import { withIsServer } from '@components/hoc';
import { BaseModal } from '@components/common/modal';
import { EPCModal } from './EPCModal';
import { AppVariant } from '@model/config/brands';
import { bannerIsActive } from '@util/promo';

interface EPCModalContainerProps {
  isServer: boolean;
  tripType?: TripTypes;
}

export const EPCModalContainer = withIsServer(({ isServer, tripType }: EPCModalContainerProps) => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const CookiesApi = new Cookies();
  const epcCookie = CookiesApi.get(Cookie.EPC);
  const modalClosed = CookiesApi.get(Cookie.CLOSE_EPC) === 'true';

  const modalType = useSelector(getModalType);
  const promoBannerData = useSelector(getPromoBannerData);
  const epcBanner = promoBannerData.find(({ epc: bannerEpc }) => bannerEpc === epcCookie);

  const modalValid = !!epcBanner && bannerIsActive(epcBanner) && (!tripType || epcBanner.tripType?.includes(tripType));

  useEffect(() => {
    if (!modalClosed && modalValid) {
      setIsModalOpen(true);
    }
  }, [modalClosed, modalValid]);

  useEffect(() => {
    if (modalType === ModalType.EPC_MODAL) {
      setIsModalOpen(true);
    }
  }, [modalType]);

  if (isServer || AppVariant.isWhitelabel() || !modalValid) {
    return null;
  }

  const setCloseCookie = () => {
    CookiesApi.set({
      id: Cookie.CLOSE_EPC,
      value: 'true',
      options: {
        path: '/',
        expires: moment().add(6, 'hours').toDate(),
        sameSite: 'strict',
        secure: true
      }
    });
  };

  const handleDismiss = () => {
    setIsModalOpen(false);
    setCloseCookie();
    dispatch(closeModal());
  };

  if (!isModalOpen) {
    return null;
  }

  return (
    <>
      <BaseModal
        open={isModalOpen}
        hideCloseButton
        isScrollBodyModal
        bgColor={'rgba(0,0,0,0.2)'}
        bdFilter={'blur(2px)'}
        onDismiss={handleDismiss}
      >
        <EPCModal onDismiss={handleDismiss} modalData={epcBanner.modal} />
      </BaseModal>
    </>
  );
});
